import React from 'react';

const defaultValue = {
    locale: 'kr',
    setLocale: () => {}
};

export default React.createContext(defaultValue);
